import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import axios from "axios";
import Notification, { showToast } from "../../components/common/notification/Notification";
import "./ContactUs.css";

const CONTACT_INFO = [
  {
    icon: MapPin,
    label: "Address",
    value: "7th Avenue Gaur City 1, Noida Extension",
  },
  {
    icon: Phone,
    label: "Phone",
    value: "+91 9818961783",
  },
  {
    icon: Mail,
    label: "Email",
    value: "allhomedesire@gmail.com",
  },
];

const EMPTY_FORM = {
  name: "",
  email_address: "",
  mobile_number: "",
  message: "",
};

function ContactUsFront() {
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [submitting, setSubmitting] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const response = await axios.post(`${baseUrl}/all/addContactUs`, formData);
      console.log("Success:", response.data);
      showToast("Query sent successfully", { type: "success" });
      setFormData(EMPTY_FORM);
    } catch (error) {
      console.log(error);
      showToast("Something went wrong, please try again", { type: "error" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <Notification />

      <section className="contact-page__hero">
        <div className="contact-page__hero-bg" />
        <div className="contact-page__hero-inner">
          <div className="contact-page__container">
            <span className="contact-page__hero-label">Get in touch</span>
            <h1 className="contact-page__hero-title">Contact Us</h1>
            <ol className="contact-page__breadcrumb">
              <li><Link to="/">Home</Link></li>
              <li><span className="contact-page__breadcrumb-sep">›</span></li>
              <li>Contact Us</li>
            </ol>
          </div>
        </div>
      </section>

      <div className="contact-page__body">
        <div className="contact-page__container">
          <div className="contact-page__layout">

            <div className="contact-page__info">
              <span className="contact-page__info-label">Reach us</span>
              <h2 className="contact-page__info-title">
                We'd love to <em>hear</em> from you
              </h2>
              <p className="contact-page__info-subtitle">
                Have a question about a property or just want to say hello?
                Drop us a message and we'll get back to you shortly.
              </p>
              <div className="contact-page__info-items">
                {CONTACT_INFO.map(({ icon: Icon, label, value }) => (
                  <div key={label} className="contact-page__info-item">
                    <div className="contact-page__info-icon">
                      <Icon size={18} />
                    </div>
                    <div>
                      <span className="contact-page__info-item-label">{label}</span>
                      <p className="contact-page__info-item-value">{value}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="contact-page__form-card">
              <h2 className="contact-page__form-title">Send a Message</h2>
              <p className="contact-page__form-subtitle">
                Fill in the details below and we'll respond within 24 hours.
              </p>

              <form onSubmit={handleSubmit} className="contact-page__form-grid">
                <div>
                  <label className="contact-page__field-label">Name</label>
                  <input
                    className="contact-page__input"
                    type="text"
                    name="name"
                    placeholder="Your full name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                <div>
                  <label className="contact-page__field-label">Email</label>
                  <input
                    className="contact-page__input"
                    type="email"
                    name="email_address"
                    placeholder="your@email.com"
                    required
                    value={formData.email_address}
                    onChange={handleChange}
                  />
                </div>

                <div>
                  <label className="contact-page__field-label">Phone</label>
                  <input
                    className="contact-page__input"
                    type="number"
                    name="mobile_number"
                    placeholder="+91 00000 00000"
                    required
                    value={formData.mobile_number}
                    onChange={handleChange}
                  />
                </div>

                <div>
                  <label className="contact-page__field-label">Message</label>
                  <textarea
                    className="contact-page__textarea"
                    name="message"
                    placeholder="Tell us how we can help…"
                    rows={4}
                    required
                    value={formData.message}
                    onChange={handleChange}
                  />
                </div>

                <button
                  type="submit"
                  className="contact-page__submit"
                  disabled={submitting}
                >
                  {submitting ? "Sending…" : "Send Message"}
                </button>
              </form>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUsFront;